import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL } from '../apiConfig'



export const detailedStageReport = createAsyncThunk(
  'stageReport/detailedStageReport',
  async ({ stage, jwtBearer, rpm }, { rejectWithValue }) => {
    try {
      let url = `${BASE_URL}pipeline/selected/credit/data?stage=${stage}`
      if (rpm) {
        url += `&rpm=${rpm}`
      }
      const response = await fetch(
        url,
        {
          headers: {
            Authorization: `Bearer ${jwtBearer}`
          }
        }
      )

      if (!response.ok) {
        if (response.status === 401) {
          window.location.reload()
        }
        return rejectWithValue(await response.json())
      }

      return await response.json()
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const detailedStageReportV2 = createAsyncThunk(
  'stageReport/detailedStageReportV2',
  async ({ stage, jwtBearer }, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${BASE_URL}pipeline/selected/credit/data/v2?stage=${stage}`,
        {
          headers: {
            Authorization: `Bearer ${jwtBearer}`
          }
        }
      )

      if (!response.ok) {
        if (response.status === 401) {
          window.location.reload()
        }
        return rejectWithValue(await response.json())
      }

      return await response.json()
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)



const stageReportSlice = createSlice({
  name: 'stageReport',
  initialState: {
    isLoading: false,
    data: null,
    dataV2: null,
    isError: false,
    error: null
  },
  reducers: {
    resetStageReportState: state => {
      state.isLoading = false
      state.isError = false
      state.error = null
    }
  },
  extraReducers: builder => {
    builder
      /* ---------- V1 ---------- */
      .addCase(detailedStageReport.pending, state => {
        state.isLoading = true
        state.isError = false
        state.error = null
      })
      .addCase(detailedStageReport.fulfilled, (state, action) => {
        state.isLoading = false
        state.data = action.payload
      })
      .addCase(detailedStageReport.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.error = action.payload
      })

      /* ---------- V2 ---------- */
      .addCase(detailedStageReportV2.pending, state => {
        state.isLoading = true
        state.isError = false
        state.error = null
      })
      .addCase(detailedStageReportV2.fulfilled, (state, action) => {
        state.isLoading = false
        state.dataV2 = action.payload
      })
      .addCase(detailedStageReportV2.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.error = action.payload
      })
  }
})

export const { resetStageReportState } = stageReportSlice.actions
export default stageReportSlice.reducer
